import axios from 'axios';

const ValidateTokenViaHeartbeat = async (
  apiBaseUri: string,
  authToken: string
): Promise<boolean> => {
  try {
    const response = await axios.get(`${apiBaseUri}/heartbeat`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });

    if (response.status !== 204) {
      console.error('Heartbeat failed with status code:', response.status);
      return false;
    }
  } catch (error) {
    console.error('Error performing heartbeat:', error);
    return false;
  }

  return true;
};

export default ValidateTokenViaHeartbeat;
